import React from 'react';
import PropTypes from 'prop-types';
import { styled } from 'twin.macro';

import { motion } from '@ubisend/framer-motion';
import { pseudoStyles } from '@ubisend/pulse-components';

import styles from './styles';

const StyledButton = styled(motion.button)`
  ${styles}
  ${pseudoStyles}
`;

const Location = ({ response, handleButtonClick, ...props }) => {
  const handleClick = () => {
    if (response.action && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (!position || !position.coords) {
            return;
          }

          const { latitude, longitude } = position.coords;
          handleButtonClick(response.action, latitude, longitude);
        }
      );
    }

    return true;
  };

  return (
    <StyledButton {...props} onClick={handleClick} type="button">
      {response.label}
    </StyledButton>
  );
};

Location.propTypes = {
  response: PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.string
  }).isRequired,
  handleButtonClick: PropTypes.func.isRequired
};

export default Location;
